import React, { useEffect, useState } from 'react';
import { subscribeToast } from '../toast';

const COLOR = { error: '#ef4444', success: '#10b981', warning: '#f59e0b', info: '#3b82f6' };
const ICON = { error: '❌', success: '✅', warning: '⏳', info: 'ℹ️' };

export default function ToastHost() {
  const [items, setItems] = useState([]);
  useEffect(() => subscribeToast(t => {
    setItems(list => [...list.slice(-3), t]);
    setTimeout(() => setItems(list => list.filter(x => x.id !== t.id)), t.ms);
  }), []);
  if (items.length === 0) return null;
  return (
    <div style={{ position: 'fixed', left: '50%', bottom: 'calc(16px + env(safe-area-inset-bottom))', transform: 'translateX(-50%)',
      display: 'flex', flexDirection: 'column', gap: 8, zIndex: 99999, width: 'min(92vw, 520px)', pointerEvents: 'none' }}>
      {items.map(t => (
        <div key={t.id} onClick={() => setItems(list => list.filter(x => x.id !== t.id))} role="status"
          style={{ pointerEvents: 'auto', cursor: 'pointer', padding: '11px 14px', borderRadius: 12, fontSize: 13.5, lineHeight: 1.4,
            background: '#111827', color: '#F9FAFB', borderLeft: `4px solid ${COLOR[t.type] || COLOR.info}`,
            boxShadow: '0 8px 24px rgba(0,0,0,0.35)', wordBreak: 'break-word' }}>
          {ICON[t.type] || ''} {t.text}
        </div>
      ))}
    </div>
  );
}
